import {createRoot, hydrateRoot} from 'react-dom/client';
import ModernWebsiteDesign from '../pages/ModernWebsiteDesign/ModernWebsiteDesign'
import "../index.css";
import "../pages/ModernWebsiteDesign/ModernWebsiteDesign.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ModernWebsiteDesign {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ModernWebsiteDesign {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ModernWebsiteDesignVC = {mount, hydrate, unmount}